import React from "react";

interface SummaryCardProps {
  totalMo: number;
  totalMt: number;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ totalMo, totalMt }) => {
  const totalMessages = totalMo + totalMt;

  return (
    <div className="mt-8 bg-white/60 backdrop-blur-sm rounded-2xl shadow-md border border-white/20 overflow-hidden">
      <div className="p-6 sm:p-8">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Total Message Traffic
          </h3>
          <div className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            {totalMessages.toLocaleString()}
          </div>
          <p className="text-gray-500 mt-2">Combined MO + MT Messages</p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4">
          <div className="text-center p-4 rounded-xl bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-100">
            <div className="text-2xl font-bold text-emerald-600">
              {totalMo.toLocaleString()}
            </div>
            <div className="text-xs text-emerald-600 font-medium mt-1">
              Mobile Originated
            </div>
          </div>
          <div className="text-center p-4 rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100">
            <div className="text-2xl font-bold text-blue-600">
              {totalMt.toLocaleString()}
            </div>
            <div className="text-xs text-blue-600 font-medium mt-1">
              Mobile Terminated
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;